import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ICerCerTipoDTO } from '../dto/cer-cer-tipo.dto';
import { ICertificadoInfoDTO } from '../dto/certificado-info.dto';
import { ICertificadoTipoDTO } from '../dto/certificado-tipo.dto';

@Injectable({
  providedIn: 'root'
})
export class CerCerTipoService {

  private urlEndPoint = environment.urlEndPoint.concat('/autenticado/cer-cer-tipo');

  constructor(private httpClient: HttpClient) { }

  public getVistaPrevia(certificadoTipos: ICertificadoTipoDTO[], cerDependencia: string, periodoInicio: string, periodoFin: string): Observable<HttpResponse<ICertificadoInfoDTO>>{
    
    console.warn(cerDependencia)
    console.warn(periodoInicio)
    console.warn(periodoFin)
    
    let parametros = new HttpParams();
    parametros = parametros.set('cerDependencia', cerDependencia);

    if (periodoInicio != '') {
      console.warn("entro per inicio")
      parametros = parametros.set('periodoInicio', periodoInicio);
    }

    if (periodoFin != '') {
      console.warn("entro per fin")
      parametros = parametros.set('periodoFin', periodoFin);
    }
    
    return this.httpClient.post<ICertificadoInfoDTO>(`${this.urlEndPoint}/obtener-vista-previa`, certificadoTipos, { params: parametros, observe: 'response' });
  }

  public generarCertificado(certificadoInfo: ICertificadoInfoDTO): Observable<any>{
    return this.httpClient.post(`${this.urlEndPoint}/generar-certificado`, certificadoInfo, { observe: 'response', responseType: 'blob' });
  }
}
